import { render, staticRenderFns } from "./ReviewsHome.vue?vue&type=template&id=899694ee&scoped=true"
import script from "./ReviewsHome.vue?vue&type=script&lang=js"
export * from "./ReviewsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899694ee",
  null
  
)

export default component.exports